import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MuiCollapse from '@material-ui/core/Collapse';
import styles from './styles'
import Chip from '@material-ui/core/Chip';
import moment from 'moment-timezone';


class MobileCollapse extends Component {
  constructor(){
    super();

    this.state = {
      inCollapse: false
    }
    this.handleCollapse = this.handleCollapse.bind(this);
  }


  handleCollapse() {
    this.setState((prevState) => ({
      inCollapse: !prevState.inCollapse
    }))}

  render() {
    const { classes, flight } = this.props;


    const GridItemXs12 = (props) => <Grid item xs={12} {...props} />

    const Collapse = (props) => {
      return (
        <MuiCollapse
          component={GridItemXs12}
          classes={{
            hidden: classes.hidden,
          }}
          {...props}
        >
            {/* This spacing has to match with the one in the container
                outside the collapse */}
            <Grid container spacing={2}>
              {props.children}
            </Grid>
        </MuiCollapse>
      )
    }

    const format = 'ddd, MMM Do [at] h:mm A';

    function formatTime(momentTime, timezone) {
      return (moment.tz(momentTime, timezone).format(format))
    }


    const _class = [ classes.chip, classes[flight.depart.status.replace(/ /g, ``)] ].join(` `);
    let departTime = flight.depart.estimated.dateTime ? (
      <div>
        <Typography>
          <b>Scheduled</b>: {formatTime(flight.depart.scheduled.moment, flight.depart.timezone)}
        </Typography>
        <Typography>
          <b>Estimated</b>: {formatTime(flight.depart.estimated.moment, flight.depart.timezone)}
        </Typography>
      </div>
    ) : formatTime(flight.depart.scheduled.moment, flight.depart.timezone);

    let arriveTime = flight.arrive.estimated.dateTime ? (
      <div>
        <Typography>
          <b>Scheduled</b>: {formatTime(flight.arrive.scheduled.moment, flight.arrive.timezone)}
        </Typography>
        <Typography>
          <b>Estimated</b>: {formatTime(flight.arrive.estimated.moment, flight.arrive.timezone)}
        </Typography>
      </div>
    ) : formatTime(flight.arrive.scheduled.moment, flight.arrive.timezone);

    return (
      <Grid container>
        <Grid item xs={12} onClick={this.handleCollapse} className={classes.center}>
          <span class="material-icons">expand_more</span>
        </Grid>
            
        <Collapse in={this.state.inCollapse}>
          <Grid item xs={4}>
            <Chip className={_class} label={flight.depart.status} />
          </Grid>
          <Grid item xs={4}>
            {departTime}
          </Grid>
          <Grid item xs={4}>
            {arriveTime}
          </Grid>
        </Collapse>
      </Grid>
    )
  }
}

MobileCollapse.propTypes = {};

export default withStyles(styles)(MobileCollapse);



// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/MobileCollapse.js